<script setup>
import NavigationTopBar from "@/features/Navigation/NavigationTopBar.vue";
import NavigationSidebar from "@/features/Navigation/NavigationSidebar.vue";
import NavigationTopBanners from "@/features/Navigation/NavigationTopBannersOld.vue";
import { useDisplay } from "@/composables/useDisplay";
import { useRoute } from "vue-router";
import { computed } from "vue";

const { isMobile } = useDisplay();
const route = useRoute();
const hideSidebar = computed(() => route.meta?.layout === "hideSidebar");
</script>

<template>
  <div
    class="app-layout"
    role="application"
  >
    <NavigationTopBanners />
    <NavigationTopBar
      class="app-layout__header"
      role="banner"
      tabindex="-1"
    />
    <div class="app-layout__body">
      <NavigationSidebar
        v-if="!isMobile && !hideSidebar"
        class="app-layout__sidebar"
        role="navigation"
        aria-label="Main navigation"
      />
      <div
        class="app-layout__content"
        tabindex="-1"
      >
        <main
          class="app-layout__inner"
          role="main"
          tabindex="-1"
        >
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.app-layout {
  overflow: hidden;
  height: 100dvh;
  display: flex;
  flex-direction: column;

  &__header {
    flex-shrink: 0;
  }

  &__body {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
  }

  &__sidebar {
    flex: 0 0 240px;
    margin: 0 8px 8px 8px;
  }

  &__content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  &__inner {
    flex-grow: 1;
    overflow: hidden;

    & > * {
      height: 100%;
      overflow: auto;
    }
  }
}
</style>
